import React, { useEffect, useState } from 'react';
import {
  Card,
  Empty,
  Row,
  Col,
  Input,
  Space,
  // Popconfirm,
  Menu,
  Dropdown,
  Button,
  Modal
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import { useDispatch } from 'react-redux';
import { getProducts, deleteProduct } from '../redux/slice';
import CustomTable from 'common/Content/CustomTable';
import FormItem from '@/common/FormItem';
import { history } from 'app/history';
import { isWipOnlyLabel } from 'utilities/lcWorkflow';
import {
  CloseOutlined,
  EyeOutlined,
  // FormOutlined,
  PlusOutlined,
  SearchOutlined,
  MoreOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import CustomButton from '@/common/CustomButton';
import moment from 'moment';

const ProductionListPage = ({ loading }) => {
  const dispatch = useDispatch();
  const [productsData, setProductsData] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState();
  const [search, setSearch] = useState('');
  // const [showDisablePopup, setShowDisablePopup] = useState(false);

  useEffect(() => {
    handleGetProductLabels();
  }, [page, search]);

  const handleGetProductLabels = () => {
    const payload = { page, search };
    dispatch(getProducts(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
        setPagination(res.payload.pagination);
      }
    });
  };
  const handleChange = (e) => {
    console.log(e);
    setSearch(e.target.value);
  };

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  const handleDeleteUser = (record) => {
    console.log(record);
    const payload = { id: record.id };
    dispatch(deleteProduct(payload)).then(() => {
      handleGetProductLabels();
      // setShowDisablePopup(false);
    });
  };

  const columns = [
    {
      title: 'Product Batch #',
      dataIndex: 'batch_no',
      key: 'batch_no',
      ellipsis: true,
      width: '300px',
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (text, record) => {
        const dr = record?.['dispensing-request'] || record?.dispensing_request;
        let name = dr?.prod_label_process_master?.process_label_name;
        let sub = dr?.prod_label_sub_process?.sub_process_name;
        // WIP-only stages (compression/inspection) have no dispensing request,
        // so fall back to the prod dispense record's own process.
        if (!name && !sub) {
          name = record?.prod_label_process_master?.process_label_name;
        }
        const suffix =
          name || sub ? ` (${name || 'NA'}${sub ? ` › ${sub}` : ''})` : '';
        return `${text || 'NA'}${suffix}`;
      }
    },
    {
      title: 'Product Name',
      dataIndex: 'equipment_name',
      key: 'equipment_name',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        return isWipOnlyLabel(record)
          ? record?.product_name
          : record?.product_detail?.name;
      }
    },
    {
      title: 'Process',
      dataIndex: 'maintainence_frequency',
      key: 'maintainence_frequency',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        return record?.prod_label_process_master?.process_label_name;
      }
    },
    {
      title: 'Stage',
      dataIndex: 'date_planned',
      key: 'date_planned',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        return record?.prod_label_stage_master?.prodlabel_stage_name;
      }
    },
    {
      title: 'Next Stage',
      dataIndex: 'date_planned',
      key: 'date_planned',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        return record?.prodlabel_nextstage_master?.prodlabel_nextstage;
      }
    },
    {
      title: 'No.of Containers',
      dataIndex: 'no_of_containers',
      key: 'no_of_containers',
      // ellipsis: true,
      width: '180px',
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Generated date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '150px',
      // ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (text) => {
        return moment(text).format('DD-MM-YYYY');
      }
    },
    {
      title: 'Hold time',
      dataIndex: 'hold_time',
      key: 'hold_time',
      ellipsis: true,
      width: '150px',
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (text) => {
        return text ? moment(text).format('DD-MM-YYYY') : 'NA';
      }
    },
    {
      // title: 'Action',
      dataIndex: 'status',
      key: 'status',
      width: '50px',
      // ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
      render: (_, record) => {
        const handleDelete = (record) => {
          Modal.confirm({
            title: `Are you sure you want to ${
              record.is_active ? 'Deactivate' : 'Activate'
            } this Product batch?`,
            icon: <ExclamationCircleOutlined />,
            content: `Product Batch #${record.batch_no}`,
            okText: record.is_active ? 'Deactivate' : 'Activate',
            okType: record.is_active ? 'danger' : 'primary',
            cancelText: 'No',
            onOk() {
              handleDeleteUser({
                id: record.id
              });
            },
            onCancel() {
              console.log('Cancelled');
            }
          });
        };

        const getMenu = (record) => (
          <Menu>
            <Menu.Item
              key="view"
              icon={<EyeOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                window.location.href = `/createLabel?id=${record.id}`;
              }}
            >
              View
            </Menu.Item>
            <Menu.Item
              key="delete"
              icon={<CloseOutlined />}
              danger
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleDelete(record);
              }}
            >
              {record.is_active ? 'Deactivate' : 'Activate'}
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown
            overlay={getMenu(record)}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button
              type="text"
              icon={<MoreOutlined style={{ fontSize: '20px' }} />}
              style={{ padding: '4px 8px' }}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        );
      }
    }
    // {
    //   title: 'Action',
    //   dataIndex: 'status',
    //   key: 'status',
    //   ellipsis: true,
    //   responsive: ['xl', 'xs', 'sm', 'xxl', 'md'],
    //   // render: (_, record) => {
    //   //   {
    //   //     return (
    //   //       <Space>
    //   //         <a href={`/createLabel?id=${record.id}`}>
    //   //           <EyeOutlined />
    //   //         </a>
    //   //         {/* <a href={`/createLabel?id=${record.id}`}>
    //   //           <FormOutlined />
    //   //         </a> */}
    //   //         <Popconfirm
    //   //           title={`Are you sure do you want to Inactive this Product batch`}
    //   //           visible={visibility(record)}
    //   //           key={record.id}
    //   //           onConfirm={(e) => {
    //   //             e.stopPropagation();
    //   //             handleDeleteUser({
    //   //               id: record.id
    //   //             });
    //   //           }}
    //   //           onCancel={(e) => {
    //   //             e.stopPropagation();
    //   //             setShowDisablePopup({ [record.id]: false });
    //   //           }}
    //   //           okText={record.is_active ? 'Deactivate' : 'Activate'}
    //   //           cancelText="No"
    //   //           okButtonProps={{
    //   //             type: record.is_active ? 'danger' : 'primary'
    //   //           }}
    //   //         >
    //   //           <CloseOutlined />
    //   //         </Popconfirm>
    //   //       </Space>
    //   //     );
    //   //   }
    //   // }
    //   render: (_, record) => {
    //     const menu = (
    //       <Menu>
    //         <Menu.Item
    //           key="view"
    //           icon={<EyeOutlined />}
    //           onClick={(e) => {
    //             e.domEvent.stopPropagation();
    //             window.location.href = `/createLabel?id=${record.id}`;
    //           }}
    //         >
    //           View
    //         </Menu.Item>
    //         <Menu.Item
    //           key="delete"
    //           icon={<CloseOutlined />}
    //           danger
    //           onClick={(e) => {
    //             e.domEvent.stopPropagation();
    //             setShowDisablePopup({ [record.id]: true });
    //           }}
    //         >
    //           {record.is_active ? 'Deactivate' : 'Activate'}
    //         </Menu.Item>
    //       </Menu>
    //     );

    //     return (
    //       <>
    //         <Dropdown
    //           overlay={menu}
    //           trigger={['click']}
    //           placement="bottomRight"
    //         >
    //           <Button
    //             type="text"
    //             icon={<MoreOutlined style={{ fontSize: '20px' }} />}
    //             style={{ padding: '4px 8px' }}
    //             onClick={(e) => e.stopPropagation()}
    //           />
    //         </Dropdown>

    //         <Popconfirm
    //           title={`Are you sure do you want to ${
    //             record.is_active ? 'Deactivate' : 'Activate'
    //           } this Product batch`}
    //           visible={visibility(record)}
    //           onConfirm={(e) => {
    //             e.stopPropagation();
    //             handleDeleteUser({
    //               id: record.id
    //             });
    //           }}
    //           onCancel={(e) => {
    //             e.stopPropagation();
    //             setShowDisablePopup({ [record.id]: false });
    //           }}
    //           okText={record.is_active ? 'Deactivate' : 'Activate'}
    //           cancelText="No"
    //           okButtonProps={{
    //             type: record.is_active ? 'danger' : 'primary'
    //           }}
    //         >
    //           <span style={{ display: 'none' }} />
    //         </Popconfirm>
    //       </>
    //     );
    //   }
    // }
  ];
  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no material requests to display
        </div>
      </span>
    )
  };

  return (
    <>
      <Row gutter={24}>
        <Col span="20"></Col>
        <Col span="4">
          <Input
            onChange={(e) => handleChange(e)}
            className={`w-100 ${styles.searchbar}`}
            justify="start"
            align="start"
            placeholder="Search by Batch #"
            prefix={<SearchOutlined />}
          />
        </Col>
      </Row>

      <Card
        title="Production Label Generation"
        className={`${styles.cardStyles_approver}`}
        extra={
          <Space size={8}>
            <CustomButton
              type="primary"
              onClick={() => window.location.replace('/miscellaneousList')}
            >
              <PlusOutlined /> Generate miscellaneous labels
            </CustomButton>
            <CustomButton
              type="primary"
              onClick={() => window.location.replace('/createLabel')}
            >
              <PlusOutlined /> Generate new labels
            </CustomButton>
          </Space>
        }
      >
        <CustomTable
          locale={locale}
          loading={loading}
          columns={columns}
          dataSource={productsData}
          pagination={{
            size: 'small',
            total: pagination?.total_records || 0,
            showSizeChanger: false,
            onChange: (page) => {
              setPage(page);
            }
          }}
          className={styles.scrolling}
          // scroll={{ x: 'auto' }}
        />
        {/* </div> */}
      </Card>
      <br />
      <FormItem className="text-center">
        <CustomButton
          className={styles.inwardButton}
          onClick={() => history.push('/dashboard')}
          type="primary"
        >
          Back to Home
        </CustomButton>
      </FormItem>
    </>
  );
};
export default ProductionListPage;
